// Trello general colors
const blue = "#0079bf";
const veryLightGray = "#091e4214";
const white = "#fff";

// From Trello Label colors
const greenLabel = "#61bd4f";
const yellowLabel = "#f2d600";
const orangeLabel = "#ff9f1a";
const redLabel = "#eb5a46";
const purpleLabel = "#c377e0";
const blueLabel = blue;
const skyLabel = "#00c2e0";
const limeLabel = "#51e898";
const pinkLabel = "#ff78cb";
const blackLabel = "#344563";
const noneLabel = "#b3bac5";

// From Trello Mod Colors
const danger = "#CF513D";
const primary = "#5aac44";

// From Trello Button
const onHoverBG = veryLightGray;
const onActiveBG = "#E4F0F6";
const onActiveColor = blue;

// From Trello Checkbox
const checkboxUncheckedBG = "#fafbfc";
const checkboxUncheckedHoverBG = "#ebecf0";
const checkboxCheckedBG = blue;
const checkboxCheckedHoverBG = "#5ba4cf";
const checkboxCheckmark = white;

// Other colors
const lightGray = "#091e4221";
const gray = ""; // ToDo: adjust grayscale - not light gray can be darker than gray
const darkGray = "#5e6c84";

const lightGreen = "#5aac4455";
const lightRed = "#CF513D55";
// const modalOverlay = "#c8c8c880";

export default {
	trelloLabelColors: {
		green: greenLabel,
		yellow: yellowLabel,
		orange: orangeLabel,
		red: redLabel,
		purple: purpleLabel,
		blue: blueLabel,
		sky: skyLabel,
		lime: limeLabel,
		pink: pinkLabel,
		black: blackLabel,
		null: noneLabel,
	},
	trelloModColors: {
		danger,
		primary
	},
	trelloButtonLinkColors: {
		onHoverBG,
		onActiveBG,
		onActiveColor
	},
	notificationColors: {
		error: {
			background: danger,
			color: white
		},
		warning: {
			background: yellowLabel,
			color: blackLabel
		},
		announcement: {
			background: greenLabel,
			color: white
		}
	},
	trelloCheckbox: {
		checkboxUncheckedBG,
		checkboxUncheckedHoverBG,
		checkboxCheckedBG: white,
		checkboxCheckedHoverBG: adjustAlpha(white, 1),
		checkboxCheckmark: primary,
		checkboxDisabledBG: veryLightGray
	},
	// trelloCheckbox: {
	// 	checkboxUncheckedBG,
	// 	checkboxUncheckedHoverBG,
	// 	checkboxCheckedBG: adjustAlpha(primary, 1),
	// 	checkboxCheckedHoverBG: adjustAlpha(primary, .8),
	// 	checkboxCheckmark,
	// },
	generalColors: {
		lightGray,
		veryLightGray,
		// gray,
		darkGray,
		lightGreen,
		lightRed,
		white,
	}
}

function adjustAlpha(color, alpha){
	return color.substring(0, 7) + Math.floor(alpha * 255).toString(16)
}